//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props: ['increditcheck', 'inapplicant'],
	data: function data() {
		return {
			creditCheck: this.increditcheck || {},
			applicant: this.inapplicant
		};
	},

	watch: {
		increditcheck: function increditcheck(newData, oldData) {
			this.creditCheck = newData;
		},
		inapplicant: function inapplicant(newData, oldData) {
			this.applicant = newData;
		}
	},
	methods: {
		acceptApplicant: function acceptApplicant() {
			var _this = this;

			var self = this;

			console.log('you did it');

			axios.post('/prototype/person/applicants/approve', { id: this.applicant.id }).then(function (response) {
				Event.$emit('update-step', 5);
				_this.$snotify.success('The applicant was approved! You can now start creating a lease!');
			});
		},
		declineApplicant: function declineApplicant() {
			var _this2 = this;

			var self = this;

			console.log('aww shucks');

			axios.post('/prototype/person/applicants/decline', { id: this.applicant.id }).then(function (response) {
				_this2.$snotify.success('The applicant was declined.');
			});
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/applicants/ApplicantCreditCheck.vue
// module id = rZva
// module chunks = 0 1